export default {
  Studies: "مطالعات",
  Layouts: "چیدمان",
  Sync: "همگام‌سازی",
  scroll: "اسکرول",
  wwwc: "سطوح روشنایی",
  zoom: "بزرگ‌نمایی",
  general: "عمومی",
  zooming: "بزرگ‌نمایی",
  annotation: "اندازه‌گیری",
  rotating: "چرخش",
  Pan: "جابجایی",
  Wwwc: "سطوح با نقطه",
  WwwcRegion: "سطوح با چندضلعی",
  Magnify: "ذره‌بین",
  Zoom: "بزرگ‌نمایی",
  Screen: "اسکرین‌شات",
  Rotate: "چرخش",
  Flip: "معکوس",
  Reset: "بازنشانی",
  Eraser: "پاک‌کن",
  ArrowAnnotate: "A - برچسب",
  Bidirectional: "صلیب",
  Angle: "زاویه",
  EllipticalROI: "E - بیضی",
  FreehandRoi: "خط آزاد",
  Length: "L - خط‌کش",
  Probe: "نقطه‌گذاری",
  RectangleRoi: "مستطیل",
  TextMarker: "یادداشت متنی",
  DragProbe: "نشانگر قابل جابجایی",
  ScaleOverlay: "مقیاس‌ها",
  OrientationMarkers: "نشانگرهای جهت",
  Brush: "مسیر دلخواه",
  CircleScissors: "بیضی",
  FreehandScissors: "شکل دلخواه",
  RectangleScissors: "مستطیل",
  Invert: "معکوس‌سازی",
  Clip: "اسکرول خودکار",
  Series: "سری‌ها",
  Report: "گزارش",
  patientId: "شناسه بیمار",
  fullname: "نام کامل",
  birthday: "تاریخ تولد",
  studyCreatedAt: "تاریخ مطالعه",
  old: "سن",
  patientSex: "جنسیت",
  "Result AI": "نتیجه تحلیل با هوش مصنوعی",
  "Download dicom": "دانلود سری‌های هوش مصنوعی",
  "Download report": "دانلود گزارش",
  Loading: "در حال بارگذاری",
  Cached: "در کش",
  male: "مرد",
  female: "زن",
  Copy: "کپی",
  "Copy ok": "کپی شد",
  "Copy error": "کپی متن با شکست مواجه شد",
  Anonymized: "ناشناس‌سازی شده",
  StackScroll: "اسکرول",
  "Result after upload message":
    "پس از پردازش مطالعه، گزارش در دسترس خواهد بود",
  "Result ai error message": "خطای پردازش، لطفاً مطالعه دیگری را بارگذاری کنید",
  error: "خطا",
  "dcm cannot loading": "فایل‌های .dcm بارگذاری نشدند",
  "error read dcm": "خطا در خواندن مطالعه",
  ai: "تحلیل با هوش مصنوعی",
  original: "مطالعه اصلی",
  "How to use title": "راهنمای استفاده از سرویس",
  "How to use": "راهنما",
  "ai accept caption": "آیا نتیجه تحلیل با هوش مصنوعی درست است؟",
  "thx for feedback": "متشکریم بابت بازخورد شما!",
  SelectedAccept: { 1: "شما اعلام کردید که نتیجه", 2: "تحلیل با هوش مصنوعی" },
  "accept yes": "درست است",
  "accept no": "نادرست است",
  "View title": "مطالعه | " + process.env.VUE_APP_INSTALL_NAME,
  Share: "اشتراک‌گذاری",
  "Share done": "آماده",
  "Share about": "لینک به کلیپ‌بورد کپی شد",
  "Cancel preset": "بازنشانی",
  Description: "توضیحات",
  "About study": "پاسخ شما",
  CheckReport: "ارسال",
  "Your description": "پاسخ شما",
  "Best description": "توصیف مرجع",
  "Teacher comment": "نظر استاد",
  "Answer exist": "تکمیل شده",
  "Answer not exist": "پاسخی وجود ندارد",
  from: "از",
  "Skip all": "رد کردن همه",
  "Add screenshot": "گرفتن اسکرین‌شات",
  "About screen info":
    "می‌توانید اسکرین‌شات گرفته و یادداشت‌ها را اضافه کنید یا فایل را از کامپیوتر بارگذاری کنید.",
  "Screenshot doned": "آماده",
  PlanarFreehandROI: "R - کانتور",
  MPR: "MPR",
  "Disable MPR First": "ابتدا MPR را غیرفعال کنید",
  Crosshairs: "MIP و محورها",
  "MPR: only for 2+": "MPR در دسترس نیست",
  "MPR: hpu tier == 0": "دستگاه شما توانایی ایجاد بازسازی را ندارد",
  "MPR: modality not support": "MPR برای مدالیته <modality> پشتیبانی نمی‌شود",
  "Cannot loading screen -- adblock":
    "اسکرین‌شات بارگذاری نشد. لطفاً VPN یا مسدودکننده تبلیغات را غیرفعال کنید",
  "Cannot loading screen -- s3 request":
    "اسکرین‌شات بارگذاری نشد. لطفاً بعداً تلاش کنید یا به پشتیبانی پیام دهید",
  "Cannot loading screen -- upload":
    "اسکرین‌شات بارگذاری نشد. لطفاً بعداً تلاش کنید یا به پشتیبانی پیام دهید",
  voi: "روشنایی",
  camera: "پان/زوم",
  "Remove?": "حذف شود؟",
  Support: "پشتیبانی",
  "Support info": "می‌توانید سوال خود را بپرسید یا مشکلی را گزارش کنید",
  "Send work?": "آیا می‌خواهید پاسخ را ارسال کنید برای بررسی؟",
  shareAIResult:
    "مشاهده نتیجه تحلیل هوش مصنوعی در پلتفرم “" +
    process.env.VUE_APP_INSTALL_NAME +
    "”:",
  "Edit study": "ویرایش پاسخ",
};
